import { render, staticRenderFns } from "./DogHouse.vue?vue&type=template&id=0afdc8d9&scoped=true"
import script from "./DogHouse.vue?vue&type=script&lang=js"
export * from "./DogHouse.vue?vue&type=script&lang=js"
import style0 from "./DogHouse.vue?vue&type=style&index=0&id=0afdc8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afdc8d9",
  null
  
)

export default component.exports